import { useEffect } from "react";
import useDeliveryMethod from "./useDeliveryMethod";
import useDeliveryAddress from "./useDeliveryAddress";
import usePickupContact from "./usePickupContact";
import { initialBuyerClientInfo } from "./useBuyerForm";

const useDelivery = ({
  cotizacionId,
  buyerClientInfo = initialBuyerClientInfo,
  onShowToast,
  onRefreshCheckoutSummary,
}) => {
  const method = useDeliveryMethod({ cotizacionId, onRefreshCheckoutSummary, onShowToast });
  const address = useDeliveryAddress({
    cotizacionId,
    buyerClientInfo,
    onShowToast,
    onRefreshCheckoutSummary,
  });
  const pickup = usePickupContact();
  const setDeliveryGeoError = address.setDeliveryGeoError;

  // Limpia el error de geocode al cambiar a pickup
  useEffect(() => {
    if (method.deliveryMethod !== "delivery") setDeliveryGeoError("");
  }, [method.deliveryMethod, setDeliveryGeoError]);

  return {
    // method
    deliveryMethod: method.deliveryMethod,
    handleDeliveryMethodChange: method.handleDeliveryMethodChange,

    // address
    deliveryAddressParts: address.deliveryAddressParts,
    isChangingDeliveryAddress: address.isChangingDeliveryAddress,
    deliverySaveLoading: address.deliverySaveLoading,
    deliveryGeoLoading: address.deliveryGeoLoading,
    deliveryGeoError: address.deliveryGeoError,
    debouncedDeliveryMapQuery: address.debouncedDeliveryMapQuery,
    defaultDeliveryAddress: address.defaultDeliveryAddress,
    areDeliveryInputsDisabled: address.areDeliveryInputsDisabled,
    handleResolveDeliveryCoordinates: address.handleResolveDeliveryCoordinates,
    handleChangeDeliveryAddressToggle: address.handleChangeDeliveryAddressToggle,
    handleDeliveryAddressPartChange: address.handleDeliveryAddressPartChange,
    handleDeliveryCommuneChange: address.handleDeliveryCommuneChange,
    deliveryCommuneCode: address.deliveryCommuneCode,
    deliveryCommuneOptions: address.deliveryCommuneOptions,
    deliveryComunasLoading: address.deliveryComunasLoading,
    deliveryComunasError: address.deliveryComunasError,
    deliveryCity: address.deliveryCity,
    deliveryCityLoading: address.deliveryCityLoading,

    // pickup
    pickupContactName: pickup.pickupContactName,
    pickupContactRut: pickup.pickupContactRut,
    pickupVehiclePlate: pickup.pickupVehiclePlate,
    deliveryObservations: pickup.deliveryObservations,
    rutError: pickup.rutError,
    plateError: pickup.plateError,
    handlePickupFieldChange: pickup.handlePickupFieldChange,
    handleObservationsChange: pickup.handleObservationsChange,
  };
};

export default useDelivery;